// Vue.js
window.Vue = require('vue');
// Vue.js bus (Non parent-child communication)
window.Bus = new Vue();

// Axios
window.axios = require('axios');
// Default headers
window.axios.defaults.headers.common = {
  'X-Requested-With': 'XMLHttpRequest',
};

// Laravel CSRF Token for axios
let token = document.head.querySelector('meta[name="csrf-token"]');
if (token) {
  window.axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content;
} else {
  console.error('CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token');
}

// Yamaha API Token for axios
let yamahaApiToken = document.head.querySelector('meta[name="yamaha-api-token"]');
if (yamahaApiToken) {
  window.axios.defaults.headers.common['X-YAMAHA-API-TOKEN'] = yamahaApiToken.content;
} else {
  console.error('Yamaha API token not found :(');
}

// Promise based HTTP client for the browser and node.js
Vue.prototype.$http = window.axios;

// Vue config for production
Vue.config.devtools = process.env.NODE_ENV !== 'production';
Vue.config.silent = process.env.NODE_ENV === 'production';



// WEBPACK FOOTER //
// ./resources/vue/bootstrap.js